import { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../../../external/components/Button/Button';
import Text from '../../../external/components/Text/Text';
import moneyHelper from '../../../helpers/money-helper';
import { State } from '../../../reducers';
import { BigNumberHelper } from '../helpers/BigNumbeHelper';
import { useLPStakingActions } from '../hooks/useLpStakingActions';
import { UseLpStakingPool } from '../hooks/usePool';
import { LpScreenEnum } from './_Screens';

interface Props {
  setWithdrawnAmount: React.Dispatch<React.SetStateAction<string>>;
  setScreen: React.Dispatch<React.SetStateAction<LpScreenEnum>>;
}

export function WithdrawConfirm({ setWithdrawnAmount, setScreen }: Props) {
  const [withdrawLoading, setWithdrawLoading] = useState(false);

  const { currencies } = useSelector(({ basic }: State) => ({
    currencies: basic.currency.USD,
  }));

  const pool = UseLpStakingPool();

  const { withdrawLP } = useLPStakingActions({ pool });

  const { unstakedBalance, rewardTokenSymbol } = pool;

  const handleWithdraw = async () => {
    if (unstakedBalance) {
      try {
        setWithdrawLoading(true);
        await withdrawLP(unstakedBalance);
        setWithdrawnAmount(unstakedBalance);
        setScreen(LpScreenEnum.WITHDRAW_SUCCESS);
      } catch (error) {
        setWithdrawLoading(false);
        setScreen(LpScreenEnum.ERROR);
        //@TODO fix error
      }
    }
  };

  return (
    <>
      <Button
        size='small'
        variant='secondary'
        dark={true}
        onClick={() => setScreen(LpScreenEnum.HOME_SCREEN)}
        disabled={withdrawLoading}
      >
        ⬅
      </Button>
      <div className='flex direction-column align-center'>
        <Text color='lightgrey' style={{ margin: '0.5rem 0' }}>
          {' '}
          You are withdrawing
        </Text>

        <Text dark={true} size='xxl' style={{ margin: '0.5rem 0' }}>
          {unstakedBalance} {rewardTokenSymbol}
        </Text>
        <Text color='green' style={{ margin: '0.25rem 0 2rem' }}>
          (
          {moneyHelper.formatUSD(
            BigNumberHelper.multiply(unstakedBalance || '0', currencies[rewardTokenSymbol] || 0),
          )}
          )
        </Text>

        <Button
          dark={true}
          variant='primary'
          onClick={handleWithdraw}
          loading={withdrawLoading}
          disabled={withdrawLoading}
        >
          {withdrawLoading ? 'Processing...' : 'Confirm withdraw'}
        </Button>
      </div>
    </>
  );
}
